const { gql } = require('@apollo/client')

export const GENERATE_NOTIFICATIONS = gql`
  mutation GenerateNotifications($content: GenerateNotificationsInput!) {
    result: generateNotifications(content: $content) {
      success
    }
  }
`
